import { render, staticRenderFns } from "./helpCentreCategory.vue?vue&type=template&id=f5f3baf4&scoped=true&"
import script from "./helpCentreCategory.vue?vue&type=script&lang=js&"
export * from "./helpCentreCategory.vue?vue&type=script&lang=js&"
import style0 from "./helpCentreCategory.vue?vue&type=style&index=0&id=f5f3baf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f3baf4",
  null
  
)

export default component.exports